import moment from 'moment';

const maxTextInputCharactersLength = 120;
const phoneMask = [
  '(',
  /\d/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

// TODO: will be removed after input international implementation
const phoneMaskSpain = [
  '(',
  '+',
  '3',
  '4',
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
];
const phoneMaskSpainView = [
  '(',
  '+',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
];
const einMask = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
const ssnMask = [
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
const codeMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

const validateNoPastTime = (dateTime: Date | null) => {
  if (!dateTime) return true;

  const timeWithoutSeconds = moment(dateTime).seconds(0).milliseconds(0);
  const currentTimeWithoutSeconds = moment(new Date())
    .seconds(0)
    .milliseconds(0);

  return timeWithoutSeconds.isSameOrAfter(currentTimeWithoutSeconds);
};

const validateNoEndDateLessStartDate = (
  startDate: Date | string,
  endDate: Date | string,
) => {
  const startDateWithoutHours = moment(startDate)
    .hours(0)
    .minutes(0)
    .seconds(0)
    .milliseconds(0);

  const endDateWithoutHours = moment(endDate)
    .hours(0)
    .minutes(0)
    .seconds(0)
    .milliseconds(0);

  return startDateWithoutHours.isSameOrBefore(endDateWithoutHours);
};

const isFieldValuesLengthValid = (values: string[], maxLength: number) => {
  const isLengthValid = values.every((value) => value.length <= maxLength);

  return isLengthValid;
};

const isMatchRegExp = (regexp: RegExp, inputValue: string): boolean => {
  return regexp.test(inputValue);
};

export {
  ssnMask,
  einMask,
  phoneMask,
  phoneMaskSpain,
  validateNoPastTime,
  isFieldValuesLengthValid,
  validateNoEndDateLessStartDate,
  phoneMaskSpainView,
  maxTextInputCharactersLength,
  isMatchRegExp,
  codeMask,
};
